<app-channels-navigation [taskListConfiguration]="taskListConfiguration"></app-channels-navigation>

<app-filters [taskListConfiguration]="taskListConfiguration" [taskListMode]="taskListMode"></app-filters>
